export enum ELocalStorageKey {
	TEST = 'test',
}
